export const ACCOUNT_REDUX_EVENTS = {
  UPLOAD_AVATAR_ATTEMPT: "UPLOAD_AVATAR_ATTEMPT",
  UPDATE_PASSWORD_ATTEMPT: "UPDATE_PASSWORD_ATTEMPT",
  CHANGE_NOTIFICATION_SETTINGS: "CHANGE_NOTIFICATION_SETTINGS",
  UNSUBSCRIBE: "UNSUBSCRIBE",
  SUBMIT_VERIFICATION_ATTEMPT: "SUBMIT_VERIFICATION_ATTEMPT",
  ACCEPTED_LICENCE_TERMS: "ACCEPTED_LICENCE_TERMS",
} as const;
type AccountReduxEvent = keyof typeof ACCOUNT_REDUX_EVENTS;

export { type AccountReduxEvent };
